// /src/store/userManagment/types.ts

import { User } from '../../dataTypes/userManagment/types';

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const FETCH_USER_BY_ID_REQUEST = 'FETCH_USER_BY_ID_REQUEST';
export const FETCH_USER_BY_ID_SUCCESS = 'FETCH_USER_BY_ID_SUCCESS';
export const FETCH_USER_BY_ID_FAILURE = 'FETCH_USER_BY_ID_FAILURE';

export const FETCH_USER_BY_EMAIL_REQUEST = 'FETCH_USER_BY_EMAIL_REQUEST';
export const FETCH_USER_BY_EMAIL_SUCCESS = 'FETCH_USER_BY_EMAIL_SUCCESS';
export const FETCH_USER_BY_EMAIL_FAILURE = 'FETCH_USER_BY_EMAIL_FAILURE';

export interface UserState {
  loading            : boolean;
  users              : Map<number, User>;
  emailToIdMap       : Map<string, number>;
  error              : string | null;
  lastFetchTimestamp : number;
  lastFetchParams    : GetUserListParams | null; // Ajouté pour stocker les paramètres de la dernière requête
}

export const initialState: UserState = {
  loading            : false,
  users              : new Map(),
  emailToIdMap       : new Map(),
  error              : null,
  lastFetchTimestamp : 0,
  lastFetchParams     : null, // Initialisé à null
};

export interface GetUserListParams {
  beginningDate? : Date;
  endingDate?    : Date;
}

export interface FetchUsersRequestAction {
  type: typeof FETCH_USERS_REQUEST;
  payload: GetUserListParams; // Ajouté pour passer les paramètres dans l'action
}

export interface FetchUsersSuccessAction {
  type: typeof FETCH_USERS_SUCCESS;
  payload: {
    users              : User[];
    lastFetchTimestamp : number;
    lastFetchParams    : GetUserListParams | null;
  };
}

export interface FetchUsersFailureAction {
  type: typeof FETCH_USERS_FAILURE;
  payload: string;
}

export interface FetchUserByIdRequestAction {
  type: typeof FETCH_USER_BY_ID_REQUEST;
}

export interface FetchUserByIdSuccessAction {
  type: typeof FETCH_USER_BY_ID_SUCCESS;
  payload: User;
}

export interface FetchUserByIdFailureAction {
  type: typeof FETCH_USER_BY_ID_FAILURE;
  payload: string;
}

export interface FetchUserByEmailRequestAction {
  type: typeof FETCH_USER_BY_EMAIL_REQUEST;
}

export interface FetchUserByEmailSuccessAction {
  type: typeof FETCH_USER_BY_EMAIL_SUCCESS;
  payload: User;
}

export interface FetchUserByEmailFailureAction {
  type: typeof FETCH_USER_BY_EMAIL_FAILURE;
  payload: string;
}

export type UserActionTypes =
  | FetchUsersRequestAction
  | FetchUsersSuccessAction
  | FetchUsersFailureAction
  | FetchUserByIdRequestAction
  | FetchUserByIdSuccessAction
  | FetchUserByIdFailureAction
  | FetchUserByEmailRequestAction
  | FetchUserByEmailSuccessAction
  | FetchUserByEmailFailureAction;
